// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__kl3TA","info":"Note_info__key_6","note":"Note_note__2o4pO","actions":"Note_actions__2nYZ0"};